export default __webpack_public_path__ + "static/Logo-auf-Weiss-RGB-c1152ca6d227cb3a2829c4a51f47338a.jpg";